export enum EnaioConnectionType {
    com = 0,
    bridge = 1,
    portalBridge = 2,
    tcp = 3
}
export namespace EnaioConnectionType{
    export function getName(value: EnaioConnectionType): string {
        switch (value) {
            case EnaioConnectionType.com:
                return "com";
            case EnaioConnectionType.bridge:
                return "bridge";
            case EnaioConnectionType.portalBridge:
                return "portalBridge";
            case EnaioConnectionType.tcp:
                return "tcp";
        }
    }
}
